module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error":"Error when generating the QR code.","tryAgain":"Try again."}}')
  delete Component.options._Ctor
}
